import React from 'react';
import classnames from 'classnames';
import { Breadcrumbs as FitBreadcrumbs, Crumb } from '@fiverr-private/fit';
import { breadcrumbs } from '../../PropTypes';
import CrumbContent from './CrumbContent';

import './style.scss';

const Breadcrumbs = ({ breadcrumbs }) => {
    const classes = classnames('header-breadcrumbs');

    if (!breadcrumbs || !Array.isArray(breadcrumbs.crumbs) || !breadcrumbs.crumbs.length) {
        return null;
    }

    const { current, crumbs } = breadcrumbs;

    return (
        <FitBreadcrumbs
            theme={FitBreadcrumbs.THEMES.PROGRESS}
            current={current}
            className={classes}
            iconClassName="crumb-icon"
        >
            {crumbs.map((value, index) => (
                <Crumb currentClassName="crumb-current" previousClassName="crumb-previous" key={index}>
                    <CrumbContent isLink={index < current}>{value}</CrumbContent>
                </Crumb>
            ))}
        </FitBreadcrumbs>
    );
};

Breadcrumbs.propTypes = {
    breadcrumbs,
};

export default Breadcrumbs;
